// src/services/FilesRequestService.ts

interface FileItem {
  name: string;
  url: string;
}

export async function getFiles(containerName: string): Promise<FileItem[]> {
  console.log(`/api/getFiles?container=${containerName}`);

  const response = await fetch(`/api/getFiles?container=${containerName}`, {
    method: 'GET',
    headers: { 'Content-Type': 'application/json' },
  });

  if (!response.ok) {
    throw new Error(`Error fetching files: ${response.statusText}`);
  }

  const data = await response.json();
  return data.files;
}
